import { render, staticRenderFns } from "./SubscriptionCategoriesTable.vue?vue&type=template&id=7b6e0f11"
import script from "./SubscriptionCategoriesTable.vue?vue&type=script&lang=ts"
export * from "./SubscriptionCategoriesTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports